import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import "../../Style.css";

import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Tr from "../../components/tr/Tr";
import List from "../../components/listing/List";
import Notification, { showToast } from "../../../components/common/notification/Notification";

const CustomerLead = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchCustomerLeads = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/customer-lead/all`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: "DESC"
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusType === "SUCCESS") {
        setData(response.data.customerLeads || []);
        setTotalPages(response.data.totalPage || 1);
      } else {
        showToast("Failed to fetch customer leads", { type: "error" });
      }
    } catch (error) {
      console.error("Error fetching customer leads:", error);
      showToast("Error occurred while fetching leads", { type: "error" });
    }
  };

  useEffect(() => {
    if (token) {
      fetchCustomerLeads();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, token]);

  const columns = [
    { displayName: "S.NO.", render: (item, index) => ((currentPage - 1) * 20) + index + 1 },
    { 
      displayName: "NAME", 
      render: (item) => `${item?.customer?.first_name || ""} ${item?.customer?.last_name || ""}` 
    },
    { 
      displayName: "MOBILE NUMBER", 
      render: (item) => item?.customer?.mobile_number || "N/A"
    },
    { 
      displayName: "EMAIL ADDRESS", 
      render: (item) => item?.customer?.email_address || "N/A"
    },
    { displayName: "TITLE", key: "title" },
    { displayName: "BUDGET", key: "budget" },
    { displayName: "CITY", key: "city" },
    { 
      displayName: "PURPOSE", 
      render: (item) => item?.purpose?.name || "N/A"
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Leads", link: "/customer-lead", active: true },
  ];

  return (
    <>
      <Notification />
      <div className="bread-crumb">
        <Container>
          <Col md={8}>
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>
      <Container fluid>
        <Row className="g-4">
          <Col lg={12} md={12} sm={12}>
            {data.length === 0 ? (
              <Tr
                columns={columns}
                initialValues={initialValues}
                title="No Leads Found..."
                titleHeader="Leads"
                btn={false}
              />
            ) : (
              <List
                title="Customer Leads"
                data={data}
                columns={columns}
                route="customer-lead"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                button="Add Lead"
                to="/customer-lead/add-lead"
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CustomerLead;
